// extracted by mini-css-extract-plugin
module.exports = {"Recommended":"Recommended_Recommended__DKzOq"};